import { Config } from "../config/config";

export const sendEmail = ({ name, email, message }: {
    name: string;
    email: string;
    message: string;
}) => {

  if (!name || !message) {
    return { success: false, message: 'Preencha todos os campos!' };
  }

  const subject = `Contato do site: ${name}`;
  const body = `Nome: ${name}\nMensagem: ${message}`;
  
  const mailtoLink = `mailto:${Config.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  
  window.open(mailtoLink, '_blank');
  
  return { success: true, message: 'Cliente de email aberto!' };
};